import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomFields from '../CustomFields';
import { ChevronDown, ChevronRight } from 'lucide-react';

class GroupField extends Component {

  state = {
    openned: true
  }

  componentWillMount () {
    const openned = this.props.config.open

    if(openned !== this.state.openned)
      this.setState({openned})
  }

  handleGroupChange = (key, value) => {
    let custom = this.props.value || {}
    custom[key] = value

    this.props.onChange({
      value: custom
    })
  }

  handleOpenClose = () => {
    let openned = !this.state.openned
    this.setState({openned})
  }

  render () {
    const { config, value, extra } = this.props
    const ToggleIcon = this.state.openned ? ChevronDown : ChevronRight

    return (
      <div>
        <div onClick={this.handleOpenClose} className='flex items-center cursor-pointer twy-text-base-accent gap-1'>
          <ToggleIcon size={14} />
          <span className='text-lg'>{config.name}</span>
        </div>
        <div className='pl-4 py-2 border-b twy-border-base'>
          {(this.state.openned && 
            <CustomFields
              config={config.items}
              onChange={this.handleGroupChange}
              custom={value}
              extra={extra}
            />
          )}
        </div>
      </div>
    )
  }
}

GroupField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.any,
  extra: PropTypes.object
}

export default GroupField;
